document.addEventListener('DOMContentLoaded', () => {
    const hamburger = document.querySelector('.hamburger-menu');
    const nav = document.querySelector('header nav');
    const productsItem = document.querySelector('.nav-item--products');
    const productsToggle = document.querySelector('.nav-products-toggle');

    const closeProductsMenu = () => {
        if (!productsItem || !productsToggle) return;

        productsItem.classList.remove('is-open');
        productsToggle.setAttribute('aria-expanded', 'false');
    };

    if (hamburger && nav) {
        hamburger.addEventListener('click', () => {
            hamburger.classList.toggle('is-active');
            nav.classList.toggle('is-open');
            document.body.classList.toggle('no-scroll');

            if (!nav.classList.contains('is-open')) {
                closeProductsMenu();
            }
        });
    }

    if (productsItem && productsToggle) {
        productsToggle.addEventListener('click', () => {
            const isOpen = productsItem.classList.toggle('is-open');
            productsToggle.setAttribute('aria-expanded', String(isOpen));
        });

        document.addEventListener('click', (event) => {
            if (!productsItem.contains(event.target)) {
                closeProductsMenu();
            }
        });

        productsItem.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                closeProductsMenu();
                productsToggle.focus();
            }
        });
    }

    const environmentFilter = document.querySelector('.environment-category-filter');

    if (environmentFilter) {
        const filterToggle = environmentFilter.querySelector('.environment-filter-toggle');

        const closeFilter = () => {
            environmentFilter.classList.remove('is-open');
            filterToggle.setAttribute('aria-expanded', 'false');
        };

        filterToggle.addEventListener('click', () => {
            const isOpen = environmentFilter.classList.toggle('is-open');
            filterToggle.setAttribute('aria-expanded', String(isOpen));
        });

        document.addEventListener('click', (event) => {
            if (!environmentFilter.contains(event.target)) {
                closeFilter();
            }
        });

        environmentFilter.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                closeFilter();
                filterToggle.focus();
            }
        });
    }
});
